import { Flex } from 'theme-ui'
import { Loading } from './Loading'

export function LoadingScreen() {
  return (
    <Flex
      sx={{
        flex: 1,
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        bg: 'background',
      }}>
      <Loading />
    </Flex>
  )
}
